import styles from "components/ui/DatePicker/DatePicker.module.css";

const DatePickerPopoverContentDivider = () => {
    return <div className={styles.divider} />;
};

export { DatePickerPopoverContentDivider };
